'use strict';

var compareWidget = require('../compare-widget'),
    productTile = require('../product-tile'),
    progress = require('../progress'),
    util = require('../util'),
    bornModules = require('../helpers/born.modules').default,
    bornPages = require('../helpers/pages').default,
    moduleViews = require('../modules/module.views').default;
import {toggleOverlay,getSelectedfilterlabels,setdefaultFilteractive,getSelectedFilterCount, breakpoints, checkTypeRefinement} from '../helpers/born.utils';
import {PLPCategoryToggle, saveStickyToggleState, setFilterScrollPosition, setOverlayInnerScroll} from './plp';
import { categoryOfferTimer } from '../offertimer';

var previousToggleRefinementEl = false;
var previousToggleSeoCatEl = false;
var wrapEvents = false;
var categoryBrandRefinement = false;

function infiniteScroll() {
	// getting the hidden div, which is the placeholder for the next page
	var loadingPlaceHolder = $('.infinite-scroll-placeholder[data-loading-state="unloaded"]');
	// get url hidden in DOM
	var gridUrl = loadingPlaceHolder.attr('data-grid-url');
	sessionStorage.scrollPos = $(window).scrollTop();

	if (loadingPlaceHolder.length === 1	&& util.elementInViewport(loadingPlaceHolder.get(0), 250)) {
		// switch state to 'loading'
		// - switches state, so the above selector is only matching once
		// - shows loading indicator
		loadingPlaceHolder.attr('data-loading-state', 'loading');
        loadingPlaceHolder.addClass('loading');

		var tileCount = $('div.search-result-content .product-grid .product-grid__item').length;
		if (SitePreferences.LISTING_HYBRID_PAGINATION) {
			gridUrl = util.appendParamToURL(gridUrl, 'count', tileCount);
		}
		// named wrapper function, which can either be called, if cache is hit,
		// or ajax repsonse is received
		var fillEndlessScrollChunk = function(html) {
			var $htmlChildren = $(html).children();                                     	
			loadingPlaceHolder.removeClass('loading');
			loadingPlaceHolder.attr('data-loading-state', 'loaded');
			$('div.search-result-content .search-result-items').append($htmlChildren);     
			$('div.search-result-content').append($(html).closest('.infinite-scroll-placeholder'));
			if (loadingPlaceHolder.attr('data-last-load') == "true" && $('.pagination').length > 0) {
            	$('.pagination').removeClass('hidden');
            }
            var scripts  = $(html).filter('.gtm-plp-data');
            eval(scripts.first().text());
		};


		$.ajax({
			type : 'GET',
			dataType : 'html',
			url : gridUrl,
			success : function(response) {
				fillEndlessScrollChunk(response);
             // put response into cache
				try {
					//sessionStorage['scroll-cache_' + gridUrl] = $('#search-result-items').html();
                    var $slickSizeSliders=$('#search-result-items .product__sizes.slick-initialized');
                    $slickSizeSliders.each((index, tile) => {
                        let $carousel=$(tile);
                        $carousel.filter('.slick-initialized').slick('unslick');
                    });
                    sessionStorage['cache-path'] = window.location.pathname;
					sessionStorage['scroll-cache'] = $('#search-result-items').html();
				} catch (e) {
					//console.log(e);
					// nothing to catch in case of out of memory of session
					// storage
					// it will fall back to load via ajax
				}
				productTile.init();
	            bornModules.carousel.init();
	            initTileSliders();
                bornModules.productRating.init();
				//var stateObj = {results: 'scroll-cache_' + gridUrl};
				var stateObj = {results: 'scroll-cache'};
				window.history.replaceState(stateObj, gridUrl, window.location.href);
				window.addEventListener('popstate', function(event) {
					window.history.pushState(stateObj, gridUrl, window.location.href);
				});
				//window.history.pushState(stateObj, gridUrl, window.location.href);
			}
		});
	}
}

function infiniteScrollOld(e, loadNextPage, repeatCount) { 
    // getting the hidden div, which is the placeholder for the next page
    var loadingPlaceHolder = $('.infinite-scroll-placeholder[data-loading-state="unloaded"]')[0];
    if (loadingPlaceHolder && (loadNextPage || util.elementInViewport(loadingPlaceHolder, 250)) ) {
        // get url hidden in DOM
        var gridUrl = loadingPlaceHolder.getAttribute('data-grid-url');

        // switch state to 'loading'
        // - switches state, so the above selector is only matching once
        // - shows loading indicator
        loadingPlaceHolder.setAttribute('data-loading-state', 'loading');
        loadingPlaceHolder.classList.add('loading');

        // named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
        var fillEndlessScrollChunk = function (html) {
            loadingPlaceHolder.classList.remove('loading');
            loadingPlaceHolder.setAttribute('data-loading-state', 'loaded');
            $('.search-result-content').append(html);
        };
        
        var scrollCallback = function (response) {
            fillEndlessScrollChunk(response);
            productTile.init();
            initTileSliders();

            //Call is already running once, so only run again if counter is over 1
            if(!util.isMobile() && repeatCount > 1) {
                infiniteScroll(false, true, repeatCount - 1);
            }
            //Check if count is down to 1.
            //Not using just 'else' cause repeatCount can be 'undefined'
            else if (repeatCount === 1) {
                scrollToPrevPos();
            }
            window.scrollTo(window.scrollX, window.scrollY+1);   
        }

        // old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
        // it was removed to temporarily address RAP-2649
        if(sessionStorage && sessionStorage['scroll-cache_' + gridUrl]) {
        	scrollCallback(sessionStorage['scroll-cache_' + gridUrl]);
        } else {
            $.ajax({
                type: 'GET',
                dataType: 'html',
                url: gridUrl,
                success: function (response) {
                    try {
                        if (sessionStorage['scroll-cache_' + gridUrl]) {
                            sessionStorage['scroll-cache_' + gridUrl] = response;
                        }else{
                        	sessionStorage.setItem('scroll-cache_' + gridUrl, response);
                        }
                    } catch (err) {
                        /* We can add error handling here for local storage quota overflow error which blocks page infinite scrolling 
                        after ~ 500-600 products loaded */
                    }
                    scrollCallback(response);
                }
            });	
        }
    }
}

function initTileSliders() {
    var $tileSliders = $('.results-container .product__link:not(.slick-slider)');

    $tileSliders.each((index, tile) => {
        tile.slickInitialSlide = moduleViews.getIndex;
    });

    bornModules.carousel.init('.product__sizes[data-slick]');
}

/**
 * Helps browsers re-position user at previous location.
 */
function scrollToPrevPos() {
    window.scrollTo(0, getStoredData() ? getStoredData().posY : 0);

    //Clear data after scroll is succesfull
    sessionStorage.removeItem('pageData');
}

function getStoredData() {
    return JSON.parse(sessionStorage.getItem('pageData'));
}

function setupInfinitePositioning() {
    var pageStoredData = getStoredData();

    if( !util.isMobile() && isSameCurrency() && pageStoredData && pageStoredData.searchURL === window.location.href ) {
        infiniteScroll(false, true, pageStoredData.currentPage);
    }

    window.addEventListener('unload', function(){
        var grids = document.querySelectorAll('.product-grid'),
            currentPage,
            currentCurrency = document.querySelectorAll('.product-grid')[0].getAttribute('data-current-currency');
        
        [].forEach.call(grids, function(grid){
            if( util.elementInViewport(grid, 0) ) {
                currentPage = parseInt(grid.getAttribute('data-current-page'));
            }
        });

        //If on first page, don't do any session storing
        if(currentPage > 0) {
            let pageData = {
                    posY: window.pageYOffset,
                    searchURL: window.location.href,
                    currentPage: currentPage
                };

            sessionStorage.setItem('pageData', JSON.stringify(pageData));
            sessionStorage.setItem('currency', currentCurrency);
            // this.scrollTo(0, pageData.posY);
        }
    });
}

function cancelEmptySearch() {
    var searchForm = document.querySelector('.cancel-empty-search');

    if(searchForm) {
        searchForm.addEventListener('submit', function(e){
            if(!this.querySelector('input[name="q"]').value.trim()) {
                e.preventDefault();
            }
        });
    }
}

/**
 * @private
 * @function
 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
 */
function updateProductListing(url, toggleLinks, isBrowserBackButton,replaceSection,addVisii) {
    var pageType=null;
    var urlParams = {'format': 'ajax'};
    if(replaceSection===undefined){
	    replaceSection='#main';
	}else{
	    pageType='brandPage';
	    urlParams.pageType = pageType;
	}
    if (!url ) { //|| url === window.location.href
        return;
    }
	progress.show($('.search-result-content'));
    if($('#categoryBrandRefinementMob').length > 0) {
        categoryBrandRefinement = $('.refinement__categorybrandrefinement:last');
        $('.refinement__categorybrandrefinement').remove();
    }
    
    $(replaceSection).load(util.appendParamsToUrl(url, urlParams),
		function () {
			
			updateCategoryRefinement(replaceSection);
			
	        compareWidget.init();
	        productTile.init();
            bornModules.toggle.init();
            bornModules.overlayToggle.init();
            bornModules.gridViewType.init();
            //bornModules.bornLazy.init();
            bornModules.selectTags.init();
            bornModules.carousel.init();
            bornModules.productRating.init();
            bornPages['.pt_product-search-result'].init();
            initTileSliders();

			// toggle filter
            var flag=false;
			toggleLinks.forEach(function(toggleLink) {
				// matchedLink = possible link that match the link clicked
                var matchedLink = document.getElementById(toggleLink.id);
				if (matchedLink) {
					if (!matchedLink.toggle) {
						flag=true;
					}else{
						matchedLink.toggle.contentEl.showContent();
					}
				}
			});

			if (flag) {
				toggleOverlay();
				document.documentElement.classList.remove('cancel-scroll');
			}
            enablePLPSeoToggle();
            triggerStickyOpen();
                const $filterElements = $(".refinements__filtercontainer .refinement");
				if(previousToggleRefinementEl && previousToggleRefinementEl.length > 0) {
					var scrollToggleID = previousToggleRefinementEl.attr('id');
					var scrollToggleEl = scrollToggleID?$('#main').find('#'+scrollToggleID):false;
					if(scrollToggleEl && scrollToggleEl.length > 0) {
						 document.getElementById(scrollToggleID)
						 	.scrollIntoView({block : "center"});
                        if(window.innerWidth < breakpoints.mobile)
                            renderfilterView(scrollToggleEl,$filterElements);
                            if(scrollToggleEl.parents('#brand_category_list').length > 0 && $('#categoryBrandRefinementMob').length > 0) {
                                $('.refinement__categorybrandrefinement:last').click();
                            }
                        else if(window.selectedStickyFilter == null && window.filteroverlay === true) {
                            $(".refinements__filtercontainer").addClass('toggle--active');
                            getSelectedfilterlabels();
                        }
                        setFilterScrollPosition();
                        setOverlayInnerScroll(scrollToggleID,"overlay");
					}else if (window.selectedStickyFilter == null && window.filteroverlay === true){
                        //Clear All scenario with data selected
                        $(".refinements__filtercontainer,.refinement-wrapper").addClass('toggle--active');
                        if(previousToggleRefinementEl.hasClass('refinement__web_clearfilter')){
                            if(window.innerWidth < breakpoints.mobile){
                                let $firstEleView = $(".refinements__filtercontainer .refinement:first");
                                $firstEleView = ($firstEleView.children().length > 0) ? $firstEleView : $firstEleView.next();
                                setdefaultFilteractive($filterElements,$firstEleView);
                            }else{
                                $filterElements.removeClass('toggle--active');
                                $filterElements.find('.toggle__link').removeClass('toggle--active');
                                $filterElements.find('.toggle__content').removeClass('toggle--active');
                            }
                        }else{
                            if(window.innerWidth < breakpoints.mobile)
                                getSelectedFilterCount();
                            else
                                getSelectedfilterlabels();
                        }
                        (scrollToggleEl.length == 0) ? toggleOverlay() :"";
                    }
                    checkTypeRefinement();
					previousToggleRefinementEl = false;
				}
                if(window.innerWidth < breakpoints.mobile) {
                    if(previousToggleSeoCatEl && previousToggleSeoCatEl.length > 0) {
                        if(previousToggleSeoCatEl.hasClass('toggle--active')) {
                            addToggleActive();
                        } else {
                            removeToggleActive();
                        }
                        previousToggleSeoCatEl = false;
                    }
			    }
			window.scrollTo(0, 0);
			progress.hide();
        	if(!isBrowserBackButton && $('.refinement-wrapper').length &&  pageType!='brandPage') {
                history.pushState(undefined, '', url); 
            }
            if(typeof addVisii !='undefined' && addVisii){
                addVisiiAttributesToWindow();
            }
            handlePLPGAEvents();
    	}
	);
}

function updateCategoryRefinement(replaceSection )
{
    if (window.innerWidth <= breakpoints.mobile) {
        try {
            if (categoryBrandRefinement && categoryBrandRefinement.length > 0) {
                if ($('#categoryBrandRefinementMob').length <= 0) {
                    $('body').append(categoryBrandRefinement);
                    $('#categoryBrandRefinementMob').hide();
                    brandLHNMobileBackAction();
                    $('#categoryBrandRefinementMob #typerefinementToggle').removeAttr('data-initialized');
                }
                var refinementsEls = $('.refinements');
                if (refinementsEls.length > 1) {
                    $('.refinements:first').remove();
                }
                var searchCountsEl = $('.search-product-count');
                if(searchCountsEl.length >1) {
                    $('.search-product-count:first').remove();
                }
                var wrapElName = replaceSection + " .refinement-toggle-hgt .refinement__all__toggle";
                if ($(wrapElName).find('.refinements').length <= 0) {
                    wrapElName = "#main .refinement-toggle-hgt .refinement__all__toggle";
                }
                if ($('#categoryBrandRefinementMob').length > 0) {
                    $("#categoryBrandRefinementMob").prependTo(wrapElName);
                    $('#categoryBrandRefinementMob #typerefinementToggle').removeAttr('data-initialized');
                    $("#categoryRefinement").remove();
                }

                $('.refinement__all__toggle #categoryBrandRefinementMob').show();
                bornModules.toggle.init();
                bornModules.overlayToggle.init();
            }
        } catch (e) {

        }
    }
}
function renderfilterView($specificEle, $generic) {
    if (window.selectedStickyFilter == null && window.filteroverlay === true) {
        $(".refinements__filtercontainer,.refinement-wrapper").addClass('toggle--active');
        let $eleParent =  $specificEle.closest('.refinement');
        let eleSelectedCount = $eleParent.find("a.refinement__link.checked").length;
        (eleSelectedCount > 0)? $eleParent.addClass('activefilter'): $eleParent.removeClass('activefilter');
        getSelectedFilterCount();
        setdefaultFilteractive($generic,$eleParent);
    }
}

function triggerStickyOpen() {

    const propagationHandler = (e) => {
        e.stopImmediatePropagation();
        e.stopPropagation();
        var $toggledElements = $('.web-sort-by-toggle,.web-sort-by-filter,.refinement__static-filter');
        if ($toggledElements.hasClass('toggle--active')) {
            $toggledElements.removeClass('toggle--active');
            //avoid sort menu closing, if clicked inside the menu
            $('#main').off('click','.web-sort-by-toggle,.web-sort-by-filter',(e) => e.stopPropagation());
            $(window).off('click', propagationHandler);
            $('body').removeClass('cancel-scroll');
        }
       saveStickyToggleState();
    }

    if (window.selectedStickyFilter != null) {
        var $allFilters = $('.refinement__static-filter:not(.refinement__sorts)');
        var $ele =  $(`#${window.selectedStickyFilter}`);
        $allFilters.removeClass('toggle--active');
        $ele.addClass('toggle--active').find('.web-sort-by-toggle, .web-sort-by-filter, .toggle__link, .toggle__content').addClass('toggle--active');
        setOverlayInnerScroll(window.selectedStickyFilter,"plp");
    }
    $('#main').on('click','.web-sort-by-toggle,.web-sort-by-filter',(e) => e.stopPropagation());
    $(window).on('click', propagationHandler);
    
}

/**
 * @private
 * @function
 * @description Initializes events for the following elements:<br/>
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents() {
    var $main = $('#main');
    // compare checked
    $main.on('click', 'input[type="checkbox"].compare-check', function () {
        var cb = $(this);
        var tile = cb.closest('.product-tile');

        var func = this.checked ? compareWidget.addProduct : compareWidget.removeProduct;
        var itemImg = tile.find('.product-image a img').first();
        func({
            itemid: tile.data('itemid'),
            uuid: tile[0].id,
            img: itemImg,
            cb: cb
        });

    });

    // handle toggle refinement blocks
    // $main.on('click', '.refinement h3', function () {
    //     $(this).toggleClass('expanded')
    //     .siblings('ul').toggle();
    // });
    
    $main.on('click', '.brandplpsearchresult .refinement-wrapper a:not(#brand_category_list a),.brandplpsearchresult .pagination a,.refinement-wrapper #brand_category_list a, .brandplpsearchresult .refinement__static-filter a,.brandplpsearchresult .breadcrumb-refinement-value a, .filter-badge a, .clear-filter-btn-container a', function (e) {
        if ($(this).parent().hasClass('unselectable')) {
            return;
        }
        if ($(this).hasClass('brand-link') && !$(this).hasClass('active')) {
            $(this).parents('.category-list.last-child').siblings('.last-child').find('a.category-click.active').removeClass('active');
            $(this).addClass('active');
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        previousToggleRefinementEl = $(this);
        previousToggleSeoCatEl = $('#catseotext-wrapper');
        updateProductListing(this.href, getToggledRefinements(),false,'#productGridContainer');
        PLPCategoryToggle();
    });
    
    // handle events for updating grid
    $main.on('click', '.refinement-wrapper a:not(#brand_category_list a), .pagination a, .refinement__static-filter:not(.refinement__sorts) a,.breadcrumb-refinement-value a', function (e) {
        // don't intercept for category and folder refinements, as well as unselectable
        //$(this).parents('.category-refinement').length > 0 || $(this).parents('.folder-refinement').length > 0 ||
        if ($(this).parent().hasClass('unselectable')) {
            return;
        }
        e.preventDefault();
        previousToggleRefinementEl = $(this);
        previousToggleSeoCatEl = $('#catseotext-wrapper');
        if($(this).hasClass('category-click')){
            var addVisii = true;
            updateProductListing(this.href, getToggledRefinements(),undefined,undefined,addVisii);
        }else{
            updateProductListing(this.href, getToggledRefinements());
        }
    });

    
    
    // handle events item click. append params.
    $main.on('click', '.product-tile a:not("#quickviewbutton")', function () {
        var a = $(this);
        // get current page refinement values
        var wl = window.location;

        var qsParams = (wl.search.length > 1) ? util.getQueryStringParams(wl.search.substr(1)) : {};
        var hashParams = (wl.hash.length > 1) ? util.getQueryStringParams(wl.hash.substr(1)) : {};

        // merge hash params with querystring params
        var params = $.extend(hashParams, qsParams);
        if (!params.start) {
            params.start = 0;
        }
        // get the index of the selected item and save as start parameter
        var tile = a.closest('.product-tile');
        var idx = tile.data('idx') ? + tile.data('idx') : 0;

        // convert params.start to integer and add index
        params.start = (+params.start) + (idx + 1);
        // set the hash and allow normal action to continue
        a[0].hash = $.param(params);
    });

    // handle sorting change
    $main.on('change', '.sort-by select', function (e) {
        e.preventDefault();
        updateProductListing($(this).find('option:selected').val(), getToggledRefinements());
    })
    .on('change', '.items-per-page select', function () {
        var refineUrl = $(this).find('option:selected').val();
        if (refineUrl === 'INFINITE_SCROLL') {
            $('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
        } else {
            $('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
            updateProductListing(refineUrl, getToggledRefinements());
        }
    });

    //handle back button functionality
    // bug: https://github.com/visionmedia/page.js/issues/213
    // workaround for IOS is below
    if (util.isSafari()) {
        $(window).one('popstate', function () {
            $(window).on('popstate', function (event) {
                updateProductListing(window.location.href, getToggledRefinements(), true);
            });
        })
    } else {
         $(window).on('popstate', function (event) {
            updateProductListing(window.location.href, getToggledRefinements(), true);
        });
    }
    
    if(window.innerWidth < breakpoints.mobile){
        // $main.on('click', '.refinement-wrapper-hgt .toggle__link:not(".refinement__all"), .refinement-wrapper-hgt .refinement__link', function () {
        //     this.scrollIntoView({block : "center"});
        // });
        
        $main.on('click', '.refinement-wrapper-hgt .refinement__clear', function () {
        	var nearToggle = $(this).closest('.toggle__link');
        	if(nearToggle && nearToggle.length > 0) {
        		previousToggleRefinementEl = nearToggle;
        		previousToggleSeoCatEl = $('#catseotext-wrapper');
        	}
        });
    }
    
}

function enablePLPSeoToggle()
{
    var initWrappEL =  $("#catseotext-wrapper");
    bornModules.toggle.init('#catseotext-wrapper');
    if(initWrappEL.length > 0) {
    	wrapEvents = jQuery._data(initWrappEL[0])["events"];
    	if(wrapEvents && wrapEvents.click !== undefined) {
    		wrapEvents = wrapEvents["click"][0].handler;
    	} else {
    		wrapEvents = false;
    	}
    }
    
    if(window.innerWidth < breakpoints.mobile){
    	removeToggleActive();
	} else {
		initWrappEL.off('click');
		addToggleActive();
	}
}

function removeToggleActive()
{
	$('#refine-catseotexthead')
		.find("div")
		.removeClass("toggle--active");
}

function addToggleActive()
{
	var seoWrappEL = $('#catseotext-wrapper');
	if(seoWrappEL.length > 0) {
		if(seoWrappEL.not('.toggle--active')) {
			seoWrappEL.addClass('toggle--active');
			var targetEl = seoWrappEL.data('toggle-target');
			if(targetEl) {
				$(targetEl).addClass('toggle--active');
			}
		}
	}
}

function isSameCurrency() {
    var currentCurrency = document.querySelectorAll('.product-grid')[0].getAttribute('data-current-currency'),
        previousCurrency = sessionStorage.getItem('currency');
    if (currentCurrency == previousCurrency) {
        return true;
    } else {
        return false;
    }
}

//Get all toggled refinements
function getToggledRefinements() {
    return [].slice.call(document.querySelectorAll('.product-search-main .toggle--active[data-toggle-target]'));
}

exports.init = function () {
	// Load window.history if history state is found
	if (window.history.state != null) {
        if(sessionStorage['cache-path'] === window.location.pathname) {
            $('#search-result-items').html(sessionStorage[window.history.state.results]);
            var loadingPlaceHolder = $('.infinite-scroll-placeholder[data-last-load="true"]');
            if (loadingPlaceHolder.length > 0 && $('.pagination').length > 0) {
                $('.pagination').removeClass('hidden');
            }
            $(window).scrollTop(sessionStorage.scrollPos || 0);
        }
	}
    compareWidget.init();
    if (!util.isMobile() && !SitePreferences.LISTING_HYBRID_PAGINATION && SitePreferences.LISTING_INFINITE_SCROLL) {
        $(window).on('scroll', infiniteScroll);
        setupInfinitePositioning();
    } else if (SitePreferences.LISTING_HYBRID_PAGINATION) {
    	$(window).on('scroll', infiniteScroll);
    }else {
        $(window).on('scroll', function () {
            //set scroll position in session storage
            sessionStorage.scrollPos = $(window).scrollTop();
        });
        $(window).onload = function () {
            window.scrollTop(sessionStorage.scrollPos || 0);
        }
    }
    productTile.init();
    initTileSliders();
    cancelEmptySearch();
    initializeEvents();
    brandLHNMobileBackAction();
    handlePLPGAEvents();
    handlePLPFilterEvents();
    bornModules.productRating.init();
    categoryOfferTimer();
};

function brandLHNMobileBackAction() {
    $('#categoryBrandRefinementMob .sub-level-wrapper .go-back').on('click', function (event) {
        event.stopPropagation();
        //$(event.currentTarget).closest('li.expandable.active').removeClass('active').find('.refinement-link:first').addClass('active');
        $(this).closest('li.expandable.active').removeClass('active').addClass('active-rm').find('.refinement-link:first').addClass('active-rp');
        $('.active-rm').find('.active').addClass('active-rp');
        $('#categoryBrandRefinementMob .category-level-1').find('li.expandable:not(.active-rm)').removeClass('active');
        $('#categoryBrandRefinementMob .category-level-1').find('.expandable:not(.active-rm)').find('a.active').removeClass('active');
        $('#categoryBrandRefinementMob .category-level-1').find('.active-rp').removeClass('active-rp').addClass('active');
    });
}

window.addEventListener('load', function () {
	if(wrapEvents === false) {
		enablePLPSeoToggle();
	}
	var catRefEl = $('#categoryBrandRefinementMob');
	if(catRefEl.length > 0) {
	    categoryBrandRefinement = catRefEl;
	}
})

$(document).ready(function () {
	var setIntervalCount = 0;
	var catgrySeoInterval = setInterval(function(){
		var objEl = $('#catseotext-wrapper');
	    var checkExist = objEl.length > 0 && objEl.data('initialized');
	    if(checkExist || setIntervalCount > 5){
	    	clearInterval(catgrySeoInterval);
	    	enablePLPSeoToggle();
	    }
        setIntervalCount += 1;
    }, 300);
    addVisiiAttributesToWindow();
});
function addVisiiAttributesToWindow(){
    var catList = $('#productRootCategoryList').length > 0 ? $('#productRootCategoryList').data('categorylist') : null;
    if(catList){
        var keys = Object.keys(catList);
        for(var i=0; i < keys.length ; i++){
            window[keys[i]] = catList[keys[i]];
        }
    }
}
function handlePLPGAEvents() {
    var user = dataLayer.find(o => o.user != null).user;
    $('.refinement__web--sortby .refinement--link').on('click',function() {
        dataLayer.push({
            "event": 'custom_event',
            "eventCategory": 'filter',
            "eventAction": 'filter_selection',
            "eventLabel":'filter-sort',
            "filter": $(this).text(),
            "country": window.GlobalAttributes.COUNTRY,
            "language": window.GlobalAttributes.LANGUAGE,
            "screenName" : 'PLP',
            "userType": user.user_id!='' ? 'logged-in' : 'logged-out',
            "userId": user.user_id!='' ? user.user_id : ''
        });
    })

    $('.product-grid-container .sticky-filters-wrapper .refinement__static-filter:not(.refinement__sorts) .refinement--link').on('click',function() {
        var filterLabel=$(this).closest('form').find('.toggle-label') ? $(this).closest('form').find('.toggle-label').text():'';
        var filterValue=$(this).find('.refinement-text') ? $(this).find('.refinement-text').text() : '';
        dataLayer.push({
            "event": 'custom_event',
            "eventCategory": 'filter',
            "eventAction": 'filter_selection',
            "eventLabel":'filter-'+filterLabel,
            "filter": filterValue,
            "country": window.GlobalAttributes.COUNTRY,
            "language": window.GlobalAttributes.LANGUAGE,
            "screenName" : 'PLP',
            "userType": user.user_id!='' ? 'logged-in' : 'logged-out',
            "userId": user.user_id!='' ? user.user_id : ''
        });
    })
    
    var queryParams=util.getQueryStringParams(window.location.search.substring(1));
    if(Object.keys(queryParams).length == 2 && queryParams.q && queryParams.lang) {
        var user = dataLayer.find(o => o.user != null).user;
        const query_param = new URLSearchParams(window.location.search).get('q');
        if ($('#search-result-items').children().length === 0) {
            dataLayer.push({
                'event': 'custom_event',
                'eventCategory': 'search',
                'eventAction': 'no_search_result',
                'eventLabel': 'no search result',
                'searchTerm': query_param,
                'country': window.GlobalAttributes.COUNTRY,
                'language': window.GlobalAttributes.LANGUAGE,
                'screenName': 'Search',
                'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
                'userId': user.user_id != '' ? user.user_id : ''
            });
        } else {
            dataLayer.push({
                'event': 'custom_event',
                'eventCategory': 'search',
                'eventAction': 'search_result',
                'eventLabel': 'search result',
                'searchTerm': query_param,
                'country': window.GlobalAttributes.COUNTRY,
                'language': window.GlobalAttributes.LANGUAGE,
                'screenName': 'Search',
                'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
                'userId': user.user_id != '' ? user.user_id : ''
            });
        }
    }
}

function handlePLPFilterEvents(){
    var user = dataLayer.find(o => o.user != null).user;
    $('body').on('click','.refinements__filter_actions .filterapply,.refinements__filter_actions .filterapply--mob',function() {
        var $selectedFilterEl=$('.badge-overflow-limit .filter-badge');
        var selectedFilterArray=[];
        if($selectedFilterEl.length>0) {
            $selectedFilterEl.each(function (key, val) {
                var filterElement=$(val);
                if(filterElement) {
                    selectedFilterArray.push(filterElement.text());
                }
            });
            var selectedFilters=selectedFilterArray.join('|');
        }
        var $selectedFilters=$('.refinement__all__toggle .toggle--nb .toggle__link.toggle--active .toggle__name');
        var selecterFilterNamesArray=[];
        if($selectedFilters.length>0) {
            $selectedFilters.each(function (key, val) {
                var filterElement=$(val);
                if(filterElement) {
                    selecterFilterNamesArray.push(filterElement.attr('title'));
                }
            });
            var selectedFilterNames=selecterFilterNamesArray.join(',');
        }
        dataLayer.push({
            "event": 'custom_event',
            "eventCategory": 'filter',
            "eventAction": 'filter_apply',
            "eventLabel":'filter-'+selectedFilterNames,
            "filter": selectedFilters,
            "country": window.GlobalAttributes.COUNTRY,
            "language": window.GlobalAttributes.LANGUAGE,
            "screenName" : 'PLP',
            "userType": user.user_id!='' ? 'logged-in' : 'logged-out',
            "userId": user.user_id!='' ? user.user_id : ''
        });
    })
        
    $('body').on('click','.refinements__filtercontainer .refinement__web_clearfilter, .refinement__selected-filters .clear-filter-btn',function() {
        var $selectedFilterEl=$('.badge-overflow-limit .filter-badge');
        var selectedFilterArray=[];
        if($selectedFilterEl.length>0) {
            $selectedFilterEl.each(function (key, val) {
                var filterElement=$(val);
                if(filterElement) {
                    selectedFilterArray.push(filterElement.text());
                }
            });
            var selectedFilters=selectedFilterArray.join('|');
        }
        dataLayer.push({
            "event": 'custom_event',
            "eventCategory": 'filter',
            "eventAction": 'filter_clear_all',
            "eventLabel":'filter clear all',
            "filter": selectedFilters,
            "country": window.GlobalAttributes.COUNTRY,
            "language": window.GlobalAttributes.LANGUAGE,
            "screenName" : 'PLP',
            "userType": user.user_id!='' ? 'logged-in' : 'logged-out',
            "userId": user.user_id!='' ? user.user_id : ''
        });
    })
}


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/search.js